import { apiRequestFactory } from "@/api/util";

const apiSpec = {
  "/user/group/children/list": {
    required: ["groupId"],
    listResponse: "groups",
  },
};

const apiRequest = apiRequestFactory(apiSpec);

export default {
  list: (options, args) => apiRequest(options, "/user/group/children/list", args),
};
